import Link from 'next/link'

import styled from 'styled-components'
import { grid, GridProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { gap, GapProps } from 'Services/Styles'

const shouldForwardProp = (prop: string | number) => {
  return !DIV_SHOULD_FORWARD_PROP.includes(String(prop))
}

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<GridProps & GapProps>`
  display: grid;
  padding-block: ${themeGet('space.11')}px;
  color: ${themeGet('colors.text.muted')};

  > div > svg {
    width: 32px;
    height: 32px;
  }

  ${grid}
  ${gap}
`

export const StyledLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: ${themeGet('colors.text.link')};
  text-decoration: none;

  &:hover {
    color: ${themeGet('colors.text.linkHover')};
    text-decoration: underline;
  }
`
